<template>
    <div class="afu-apply-documents-container afu-mt-2 md:afu-mt-0">
        <C1Tabs :title="$t('resume.upload_documents')">
            <C1Tab
                :name="$t('resume.title')"
                :selected="true"
            >
                <ApplyResume ref="resume" />
            </C1Tab>
            <C1Tab :name="$t('cover_letter.title')">
                <ApplyCoverLetter ref="coverLetter" />
            </C1Tab>
            <C1Tab :name="$t('additional_document.title')">
                <ApplyAdditionalDocument ref="additionalDocument" />
            </C1Tab>
        </C1Tabs>
    </div>
</template>

<script>
    import C1Tabs from '@/components/C1Components/C1Tabs';
    import C1Tab from '@/components/C1Components/C1Tab';
    import ApplyResume from './ApplyResume';
    import ApplyCoverLetter from './ApplyCoverLetter';
    import ApplyAdditionalDocument from './ApplyAdditionalDocument';

    export default {
        name: 'ApplyDocuments',

        components: {
            C1Tabs,
            C1Tab,
            ApplyResume,
            ApplyCoverLetter,
            ApplyAdditionalDocument,
        },
    };
</script>
